<script>
import LeaveForm from '@views/leaves/leave-form';
import beforeLeaveAfterEdit from '@mixins/beforeLeaveAfterEditModal';

export default {
  components: {
    LeaveForm,
  },
  mixins: [beforeLeaveAfterEdit],
  props: {
    // eslint-disable-next-line
    value: {
      default: null,
    },
    // eslint-disable-next-line
    loadedId: {
      default: null,
    },
  },
  data() {
    return {
      showModal: false,
    };
  },
  watch: {
    value(val) {
      if (val) {
        this.showModal = true;
      } else {
        this.showModal = false;
      }
    },
  },
  methods: {
    submit(leave) {
      this.setUnchanged();
      this.$emit('updated', leave);
    },
    hide(bvEvt) {
      this.beforeModalClose(bvEvt, () => {
        this.setUnchanged();
        this.$refs.leaveModal.hide();
      });
    },
  },
};
</script>

<template>
  <b-modal
    ref="leaveModal"
    v-model="showModal"
    size="lg"
    hide-footer
    :title="loadedId === 'new' ? $t('titles.create_leave') : $t('titles.edit_leave')"
    static
    @hide="hide" @hidden="$emit('hidden')">
    <LeaveForm v-if="showModal" :loaded-id="loadedId" @submitted="submit" @entity-changed="initBeforeLeave" />
  </b-modal>
</template>
